module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.17685/js/img/valuePropModals/SequencesEmailCommunicator/ValueProp2.svg"